import commonStore from '../../store/commonStore.js';
import * as general from '../general/general';
import _, { isEmpty } from 'lodash';
import $ from 'jquery';
import { addParam } from '../general/general';
import { getStaticEPFAccessToken } from './EpfTokensUtils';

export const decode = (s: string) => {
    return decodeURIComponent(s.replace(/\+/g, " "));
};

export const getQueryStrings = () => {
    const assoc: any = {};
    const queryString = window.location.search.substring(1);
    const keyValues = queryString.split('&');
    for (const i in keyValues) {
        if (keyValues.hasOwnProperty(i)) {
            const key = keyValues[i].split('=');
            if (key.length > 1) {
                assoc[decode(key[0])] = decode(key[1]);
            }
        }
    }
    return assoc;
};

const getInitialData = () => {
    return (window.HTML_RENDITION && window.HTML_RENDITION.initialData) || commonStore.getState().asyncStateReducer.initialData;
};

export const getContextPath = (contentType: string) => {
    const _HTML_RENDITION = getInitialData();
    if (getQueryStrings()['static'] && getQueryStrings()['static'] == 'true') {
        return general.documentsPath_version + 'test/' + _HTML_RENDITION.doc_id;
    }
    let relativePath = '';
    // First time to load header json, general.isTimedLinkAvailable is undefined.
    const isTimedLinkAvailable = window.HTML_RENDITION.initialData.isTimedLinkAvailable || false;
    switch (contentType) {
        case 'json':
            relativePath = ((isTimedLinkAvailable) ? _HTML_RENDITION.unProtectedPath : _HTML_RENDITION.protectedPath) + _HTML_RENDITION.doc_id;
            break;
        case 'akesi_json':
            relativePath = ((_HTML_RENDITION.isStaticView || isTimedLinkAvailable) ? _HTML_RENDITION.unProtectedPath : _HTML_RENDITION.header_protected_path) + _HTML_RENDITION.doc_id;
            break;
        case 'image':
            relativePath = _HTML_RENDITION.unProtectedPath + _HTML_RENDITION.doc_id;
            break;
        case 'css':
            relativePath = _HTML_RENDITION.unProtectedPath + _HTML_RENDITION.doc_id;
            break;
        case 'html':
            relativePath = _HTML_RENDITION.unProtectedPath + _HTML_RENDITION.doc_id;
            break;
        default:
            break;
    }
    return relativePath;
};

export const getImagePath = (imageName: string) => {
    if (!imageName) {
        return '/';
    }
    // Absolute URL (for example: http://images.com/play.png )
    if (imageName.indexOf("http") === 0) {
        return imageName;
    }

    const {extractionCompletionMillisec, version, buildTimeStamp} = commonStore.getState().asyncStateReducer.initialData;
    const timeStamp = window.HTML_RENDITION.initialData.isNewOutput ? extractionCompletionMillisec : buildTimeStamp;
    // Static (for example: /img/play.png )

    let retImagePath = '';
    if (imageName.indexOf('/') === 0) {
        retImagePath = general.documentsPath_version() + imageName.substring(1, imageName.length) + "?ts=" + timeStamp;
    } else {
        retImagePath = getContextPath('image') + "/" + imageName + "?ts=" + timeStamp + "&version=" + version;
    }
    const epfToken = getStaticEPFAccessToken();
    if (!isEmpty(epfToken)) {
        retImagePath = addParam(retImagePath, '__epftoken', epfToken);
    }
    return retImagePath;
};

export const getParamsForProtectedCall = () => {
    const _HTML_RENDITION = getInitialData();
    let params = '';
    if (_HTML_RENDITION.legacyURL == 'true') {
        params = 'id=' + _HTML_RENDITION.id;    // params = 'id=' + encryptedId
        if (_HTML_RENDITION.parent_doc_id != null)
            params += "&parent_doc_id=" + _HTML_RENDITION.parent_doc_id;
    }
    else {
        let dynamicData = _HTML_RENDITION.dynamicData;
        let staticData = _HTML_RENDITION.staticData;
        if (dynamicData == 'null') {
            dynamicData = '';
        }
        if (staticData == 'null') {
            staticData = '';
        }
        params += 'encodedDynamic=' + dynamicData;
        params += '&encodedStatic=' + staticData;
    }
    params += "&doc_id=" + _HTML_RENDITION.doc_id;

    if (general.isTimedLinkAvailable && general.getLinkId()){
        params += '&linkId=' + general.getLinkId();
    }
    return params;
};

export const getParamsForTest = function () {
    const _HTML_RENDITION = getInitialData();
    function isInternalUseOnly() {
        return _HTML_RENDITION.urlParameters && _HTML_RENDITION.urlParameters.internal_use_only == 'true';
    }
    let params = '';
    if (isInternalUseOnly()) {
        $.each(_HTML_RENDITION.urlParameters, function (key: any, value: any) {
            params += "&" + key + "=" + value;
        });
    }
    return params;
};
export const getJsonPath = (jsonName: string) => {
    const _HTML_RENDITION = getInitialData();
    let jsonPath = (jsonName == 'header_section')
        ? getContextPath('akesi_json') : getContextPath('json');
    const prefix = (_.isUndefined(_HTML_RENDITION.device_prefix) || _.isNull(_HTML_RENDITION.device_prefix)) ? '' : _HTML_RENDITION.device_prefix;
    jsonPath += "/" + prefix + jsonName + ".json?";
    jsonPath += getParamsForProtectedCall();
    jsonPath += getParamsForTest();
    if (window.HTML_RENDITION.initialData.isPublic){
        jsonPath += ('&ts=' + window.HTML_RENDITION.initialData.extractionCompletionMillisec);
    }
    if (['figure_gallery', 'catalystWatch'].includes(jsonName) && _HTML_RENDITION.isStaticHtmlExport){
        jsonPath += '&show_html_only=true&internal_use_only=true';
    }
    if ((jsonName == 'figure_gallery' || jsonName == 'catalystWatch' || jsonName == 'finsum') && _HTML_RENDITION.mode == 'static_view'){
        jsonPath += '&static_view=true';
        if (_HTML_RENDITION.productType){
            jsonPath += ('&productCode=' + _HTML_RENDITION.productType.toUpperCase());
        }
    }
    return jsonPath;
};
